import React, { useState, useEffect } from 'react'
import Typography from '@mui/material/Typography'
import { grey } from '../../../../colors'
import CustomTooltip from '../../../CustomTooltip'
import { Box } from '@mui/material'
import { TextListWrapper, ToolTipWrapper } from './styles'

interface TextListProps {
  list: string[] | []
  disabled?: boolean
}

const TextList: React.FC<TextListProps> = ({ list = [], disabled = false }) => {
  const [sortedList, setSortedList] = useState<string[] | []>([])

  useEffect(() => {
    if (list?.length) {
      setSortedList([...list].sort((a, b) => a.localeCompare(b)))
    }
  }, [list])

  const displayedValue = sortedList?.[0]
  const tooltipsValues = sortedList.slice(1)

  const Title = (): JSX.Element => (
    <Box display="flex" gap={1} flexWrap="wrap">
      {tooltipsValues?.map((item, index) => (
        <Typography key={index} fontWeight={600} color={grey[0]} fontSize="12px">
          {item}
          {index !== tooltipsValues.length - 1 && ','}
        </Typography>
      ))}
    </Box>
  )

  return (
    <TextListWrapper color={grey[disabled ? 350 : 850]}>
     <Typography fontSize={'14px'}>
        {displayedValue}
      </Typography>
      {list.length > 1 && (
        <ToolTipWrapper>
          <CustomTooltip title={<Title />}>...</CustomTooltip>
        </ToolTipWrapper>
      )}
    </TextListWrapper>
  )
}

export default TextList
